export const CONSTANTS = {
  BAB: "Behavior Assessment Battery for School-Age Children and Adolescents who Stutter",
  SSCERID: "ssc-er",
  SSCSDID: "ssc-sd",
  BCLID: "bcl",
  CATID: "cat",
  BAB1: "Behavior Assessment Battery",
  BAB2: "for School-Age Children and Adolescents Who Stutter",

  FOOTERTEXTLEFT: "© Copyright 2026 - Plural Publishing, Inc. All Rights Reserved.",
  FOOTERTEXTRIGHT: "By Martine Vanryckeghem, PhD & Gene J. Brutten, PhD",

  CLINICALLYSIGNIFICANT: "Clinically Significant",
  CLINICALLYINSIGNIFICANT: "Not Clinically Significant",
  ANSWERALLBEFORESUBMIT: "Please answer all questions before submitting.",

  SELECTTEST: "Click below to complete each self-report test",
  ABOUTBAB:"About the BAB",
  SAMPLEBABTEXT:"This is a sample About the BAB section.",
  ONGOINGTEST: "Ongoing Test",
  STARTOVER: "Start Over",
  CANCEL: "Cancel",
  SESSIONEXPIRED: "Your session has expired!",
  TESTINPROGRESS: "Test already in progress...",
  DOWNLOAD: "Download",
  DOWNLOADPDF: "Download PDF",
  DOWNLOADMANUAL:"MANUAL (PDF)",
  PREPARINGPDF: "Preparing PDF",
  BACKTOTEST: "Back to Test",
  BACKTOQUIZZES: "Back to All Tests",
  RESULT: "Result",
  RESULTS: "Results",
  TOTALSCORE: "Total Score",
  INTERPRETATION: "Interpretation",
  METRIC: "Metric",
  VALUE: "Value",
  TESTRESULT: "Test Result",
  VIEWRESULT: "View Results",
  NORESPONSE: "No response",
  ANSWER: "Answer",
  SELECTANSWER: "Please select an answer",
  CHECKACCESS: "Checking access...",
  BACKTOPLURAL: "Back to Plural Website",
  UNAUTHORIZED: "Sorry, you are not authorized to access this page.",
  TESTINPROGRESSMESSAGE: <div>
    Looks like a test is already in progress in another session.<br />
    Please finish with the ongoing test to start a new one or start a fresh test.
  </div>
}

export const TESTS = [
  "ssc-er", "ssc-sd", "bcl", "cat",
]